import { NO_DATA_MESSAGE, PersonHttpHelper } from '../../utils/HttpHelper';

const getPersonAcknowledgementsAddAFamilyMember = (id, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);
    
    const idForUrl = id ? encodeURIComponent(id) : 'NaN';
    const url = `/PersonAcknowledgement/Member/${idForUrl}/Forms`;
    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default getPersonAcknowledgementsAddAFamilyMember;
